import { useCallback, useState, useEffect } from 'react';
import { Option, UnitEntityInterface } from '@types';
import { TextField } from '@material-ui/core';
import { getAllUnits } from '@services/unitService';
import { translate } from '@utils';
import isEmpty from 'lodash/isEmpty';
import Autocomplete from '@sharedComponents/Autocomplete';

const renderInput = (params) => {
  return <TextField {...params} placeholder={translate('search')} />;
};

const renderOption = (option: Option<UnitEntityInterface>) => (
  <div className="management-autocomplete-option" key={option.value.id}>
    <span className="management-autocomplete-option__name">{option.value.name}</span>
    {option.value.roles?.map((role, id) => (
      <span key={id} className="management-autocomplete-option__role">
        {role.name}
      </span>
    ))}
  </div>
);

const getOptionDisabled = (option: Option<UnitEntityInterface>) => {
  return !isEmpty(option?.value.roles) || option.disabled;
};

export const UnitSearch = ({ onChange, tableUnits }) => {
  const [options, setOptions] = useState<Option<UnitEntityInterface>[]>([]);
  const [previewUnits, setPreviewUnits] = useState<UnitEntityInterface[]>([]);

  useEffect(() => {
    setOptions(
      previewUnits.map((item) => {
        return {
          value: item,
          label: item.longName,
          disabled: Boolean(tableUnits.find((unit) => unit.id === item.id)),
        };
      })
    );
  }, [previewUnits, tableUnits]);

  const onInputChange = useCallback(
    async (event, value) => {
      const { items } = await getAllUnits({ search: value, limit: 5 });
      setPreviewUnits(items);
    },
    [tableUnits]
  );

  return (
    <Autocomplete
      options={options}
      renderInput={renderInput}
      onInputChange={onInputChange}
      onChange={onChange}
      renderOption={renderOption}
      getOptionDisabled={getOptionDisabled}
    />
  );
};
